import { useLocation } from 'react-router'

const pathnameRegex = /(\d+)/

const useProductIdFromPath = () => {
  const { pathname } = useLocation()
  const ids = pathname.match(pathnameRegex)
  if (ids?.length) {
    // eg /p/only-sons/hose-mark-pant-gw-0209-4305913/product-reviews
    return parseFloat(ids[ids.length - 1])
  }

  return null
}

export default useProductIdFromPath
